import cn from 'classnames';
import type React from 'react';

import { CloseLineIcon, TagLineIcon } from '../../icons';
import { Select } from '../../select';
import type Form from '../Form';
import { Item } from '../item';

type InputType = React.ComponentProps<typeof Select>;

type ItemType = {
  label?: string;
} & Omit<React.ComponentProps<typeof Form.Item>, 'label'>;

type P = {
  input?: InputType;
  item?: ItemType;
};

const defaultItemProperties: ItemType = {};
const defaultInputProperties: InputType = {};

const TagsInput = ({
  input: { className, emptyProps, ...restInput } = defaultInputProperties,
  item = defaultItemProperties,
}: P) => (
  <Item {...item}>
    <Select
      allowClear
      className={cn('tags-input', className)}
      emptyProps={{ image: <TagLineIcon />, ...emptyProps }}
      mode="multiple"
      optionFilterProp="label"
      removeIcon={<CloseLineIcon />}
      {...restInput}
    />
  </Item>
);

export default TagsInput;
